import { SvgIcon } from '@avantia/style-guide';
import type { HpSvgIconTypes } from '@avantia/style-guide';
import { ToggleButtonGroup, ToggleButton } from 'react-bootstrap';

import { HpAlert } from '../alert';
import './cardSelector.scss';

interface Card {
  id: string;
  name: string;
  icon: HpSvgIconTypes;
}
interface CardSelectorProps {
  cards: Card[];
  setSelectedCard: (cardId: string) => void;
  selectedCard: string;
  error?: string;
}

export const CardSelector = ({ cards, setSelectedCard, selectedCard, error }: CardSelectorProps): JSX.Element => {
  return (
    <>
      {error && (
        <HpAlert
          iconType={'exclamation' as HpSvgIconTypes}
          message={<p className="error-text">{error}</p>}
          alertLevel="error"
          className="error-alert"
        />
      )}
      <ToggleButtonGroup type="radio" name="options" vertical className="card-selector-group">
        {cards.map((card) => (
          <ToggleButton
            value={card.id}
            id={`card-selector-${card.id}`}
            key={card.id}
            onChange={() => setSelectedCard(card.id)}
            checked={selectedCard === card.id}
            className={selectedCard === card.id ? 'card-selector-button-selected' : 'card-selector-button'}>
            <SvgIcon type={card.icon} />
            <p className="card-selector-button-text">{card.name}</p>
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </>
  );
};
